import axios from 'axios'

// 创建axios对象
export const api = axios.create({
    baseURL: 'http://192.168.3.36:8085/api',
    timeout: 9000 // 请求的超时
})

// 创建axios对象
export const Interface = axios.create({
    baseURL: 'http://10.12.3.47:32096/Interface',
    timeout: 9000 // 请求的超时
})

// 添加请求拦截器,
api.interceptors.request.use(
    request => {
        let token = `eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyX2lkIjoiMTIzNDU2In0.J1Z4DA021s0jboDwJ37tT2hR-ZSh1i_yZysWnSGh-lg`
        if (token) {
            // 设置请求的头信息
            request.headers = {
                'token': token, // 请求添加的token
                'Content-Type': 'application/json;charset=utf-8'
            }
        }
        return request
    },
    error => {
        Promise.reject(error)
    }
)

// 添加响应拦截器
api.interceptors.response.use(
    response => {
        return response.data
    },
    error => {
        Promise.reject(error)
    }
)

// 添加请求拦截器,
Interface.interceptors.request.use(
    request => {
        let token = `eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyX2lkIjoiMTIzNDU2In0.J1Z4DA021s0jboDwJ37tT2hR-ZSh1i_yZysWnSGh-lg`
        if (token) {
            // 设置请求的头信息
            request.headers = {
                'token': token, // 请求添加的token
                'Content-Type': 'application/json;charset=utf-8'
            }
        }
        return request
    },
    error => {
        Promise.reject(error)
    }
)

// 添加响应拦截器
Interface.interceptors.response.use(
    response => {
        return response.data
    },
    error => {
        Promise.reject(error)
    }
)

export default axios